import * as types from '../../action-types';
import {applyForFunding as initialState } from "../../initialState";

const applyForFunding = (state=initialState, action) => {
  switch (action.type) {
    case types.APPLY_FOR_FUNDING_START:
      return {
        ...state,
        isLoading: true
      };
    case types.APPLY_FOR_FUNDING_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.APPLY_FOR_FUNDING_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.APPLY_FOR_FUNDING_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default applyForFunding;
